<template>
  <div class="mt-4 mb-3 card mt-lg-0">
    <div class="pb-0 card-body">
      <div class="mb-3 row align-items-center">
        <div class="col-9">
          <h5 class="mb-1 text-gradient text-success">
            <a href="javascript:;">{{ title }}</a>
          </h5>
        </div>
      </div>
      <ul class="mx-auto list-unstyled">
        <li v-for="a in sortedApprovals" :key="a.id" class="d-flex mb-3">
          <div class="d-flex px-2 py-1">
            <vsud-avatar :img="getPhoto(a.approver?a.approver:a.approved)"  class="me-2"
                      alt="avatar image"
                      border-radius="lg" />
          </div>
          <p style="cursor: pointer; color:#1155cc" @click="viewProfile(a.approver ? a.approver.id : a.approved.id)"
            class="mb-0">{{ getFullName(a) }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import router from "@/router/index.js";
import imgDefault from "../../../../assets/img/user-default.png";
import VsudAvatar from "@/components/VsudAvatar.vue";
export default {
  name: "ApprovalsCard",
  components: { VsudAvatar },
  props: {
    title: { type: String, default: "" },
    type: { type: String },
    approvals: { type: Object, require: true },
  },
  data() {
    return {
      showMenu: false,
      imgDefault
    };
  },
  computed: {
    sortedApprovals() {
      // Utiliza Array.sort() para ordenar las asignaturas alfabéticamente
      return this.approvals.slice().sort((a, b) => {
        const nameA = this.getFullName(a).toUpperCase(); // Utilizar la función getFullName
      const nameB = this.getFullName(b).toUpperCase();

        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        return 0; // Son iguales
      });
    }
  },
  methods: {
    viewProfile(id) {
      router.push({
        path: `/ver/usuario/${id}`,
      });
    },
    getPhoto(user){
      if(user.photo){
        return user.photo
      }
      else{
        return imgDefault
      }
    },
    getFullName(user) {
      if (user.approver) {
      return `${user.approver.name} ${user.approver.lastname}`;
    } else {
      return `${user.approved.name} ${user.approved.lastname}`;
    }
  },
  },
};
</script>
